/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We do not sell your personal data to third parties. We may share anonymized, aggregated data that cannot be used to identify you.`)
};

const es_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No vendemos tus datos personales a terceros. Podemos compartir datos anonimizados y agregados que no pueden usarse para identificarte.`)
};

const de_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verkaufen Ihre persönlichen Daten nicht an Dritte. Wir können anonymisierte, aggregierte Daten teilen, die nicht zu Ihrer Identifizierung verwendet werden können.`)
};

const nl_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We verkopen uw persoonlijke gegevens niet aan derden. We kunnen geanonimiseerde, geaggregeerde gegevens delen die niet kunnen worden gebruikt om u te identificeren.`)
};

const fr_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous ne vendons pas vos données personnelles à des tiers. Nous pouvons partager des données anonymisées et agrégées qui ne peuvent pas être utilisées pour vous identifier.`)
};

const it_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non vendiamo i tuoi dati personali a terzi. Potremmo condividere dati anonimizzati e aggregati che non possono essere utilizzati per identificarti.`)
};

const pt_br2_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não vendemos seus dados pessoais a terceiros. Podemos compartilhar dados anonimizados e agregados que não possam ser usados para identificá-lo.`)
};

const pt_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não vendemos os seus dados pessoais a terceiros. Podemos partilhar dados anonimizados e agregados que não podem ser usados para o identificar.`)
};

const ja_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お客様の個人データを第三者に販売することはありません。お客様を特定できない匿名化・集計データを共有する場合があります。`)
};

const zh_privacy_no_data_sale = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们不会将您的个人数据出售给第三方。我们可能会共享无法用于识别您身份的匿名汇总数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_no_data_sale = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_no_data_sale(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_no_data_sale", locale)
	if (locale === "en") return en_privacy_no_data_sale(inputs)
	if (locale === "es") return es_privacy_no_data_sale(inputs)
	if (locale === "de") return de_privacy_no_data_sale(inputs)
	if (locale === "nl") return nl_privacy_no_data_sale(inputs)
	if (locale === "fr") return fr_privacy_no_data_sale(inputs)
	if (locale === "it") return it_privacy_no_data_sale(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_no_data_sale(inputs)
	if (locale === "pt") return pt_privacy_no_data_sale(inputs)
	if (locale === "ja") return ja_privacy_no_data_sale(inputs)
	return zh_privacy_no_data_sale(inputs)
};